import React, { useRef, useState, useEffect } from "react";
import { Button, Container } from "react-bootstrap";
import { loadModules } from "esri-loader";
import style from "./form.module.scss";
import { UrlServices, UrlServicesFiltros,UrlServicesFiltrosView, URLPortal } from "../../.config";
const TODIS_MAP = (props) => {

  var view = null;
  var webmap = null;
  const mapEl = useRef(null);
  const [dateForm, setDateForm] = useState("")
  const [webMap, setWebMap] = useState(null);
  const [filtros, setfiltros] = useState({regionalPartner:'', sector:'', networkType:'',tent_category:'', dateForm:dateForm});
  const [viewMap, setViewMap] = useState(null);
  const filterSpatial = (data, layerDraw, callback) => {
    var element = document.getElementById("tblResult");
    document.getElementById("tblResult").innerHTML = "";
    document.getElementById("tblResult").style.display = "none";
    element.classList.remove("table-size");
    props.expandingResultTable(false);
    var message = "";
    if (!data) {
      message += " You must select the sector";
      message += "\n You must select the Network Type";
    }
    if (data && data.sector =='') {
      message += " You must select the sector";
    }
    if (data && data.networkType =='') {
      message += "\n You must select the Network Type";
    }
    if (message != "") {
      alert(message);
      callback();
      return;
    }

    loadModules(["esri/core/urlUtils", "esri/layers/FeatureLayer", "esri/widgets/FeatureTable", "esri/widgets/FeatureTable/Grid/support/ButtonMenu"], {
      css: true
    }).then(([urlUtils, FeatureLayer, FeatureTable, ButtonMenu]) => {
      const parcelQuery = {
        spatialRelationship: "intersects", // Relationship operation to apply
        geometry: layerDraw.graphics.items[0].geometry,  // The sketch feature geometry
        outFields: ["*"], // Attributes to return
        returnGeometry: true
      };
      var itemAt = getItemLayer(data);
      const featureLayer2 = window.webmap.layers.getItemAt(itemAt);
      
      featureLayer2.queryFeatures(parcelQuery)
      .then((results) => {       
        document.getElementById("tblResult").style.display = "";       
        element.classList.add("table-size");
        props.expandingResultTable(true);        
        var ids = results.features.map(function(x) { return x.attributes["npm_road_id"]});
        let view = window.view;
        view.goTo(results.features);
        window.features = results.features;
        if (featureLayer2.popupTemplate) {
          featureLayer2.popupTemplate.actions = [
            { id: "openFileProject", title: "See File", className: "esri-icon-documentation" }
          ];
        }          
        featureLayer2.definitionExpression = "npm_road_id in ("+ids.join(",")+")";
        //featureLayer.title = "Feature Roads";
        
        //webMap.add(featureLayer);
        // Create the feature table
        const featureTable = new FeatureTable({
          layer: featureLayer2,
          multiSortEnabled: true,
          view: window.view, // required for feature highlight to work
          //fieldConfigs: fieldConfigs,
          attachmentsEnabled: false,
          visibleElements: {
              selectionColumn: true,
              header: true,
              menu: true
          },
          container: document.getElementById("tblResult")
        });
        
        featureTable.when(e => {
          console.log(e);
        })
        //console.log('ejecutar callback');
        callback();

      }).catch((error) => {
        console.log(error);
      });

    });

  }

  const getItemLayer = (data) =>{
    var itemAt = 0;

    if (data.sector == "1" && data.networkType=="0"){
      itemAt = 4;
    }
    else if (data.sector == "1" && data.networkType=="1"){
      itemAt = 6;
    }
    else if (data.sector == "1" && data.networkType=="2"){
      itemAt = 5;
    }
    else if (data.sector == "2" && data.networkType=="0"){
      itemAt = 9;
    }
    else if (data.sector == "2" && data.networkType=="1"){
      itemAt = 10;
    }
    else if (data.sector == "2" && data.networkType=="2"){
      itemAt = 11;
    }
    else if (data.sector == "3" && data.networkType=="0"){
      itemAt = 14;
    }
    else if (data.sector == "3" && data.networkType=="1"){
      itemAt = 15;
    }
    else if (data.sector == "3" && data.networkType=="2"){
      itemAt = 16;
    }
    return itemAt;
  }
  const setFields = (data) => {
    document.getElementById("ddlFields").innerHTML = "";
    var message = "";
    if (!data) {
      message += " You must select the sector";
      message += "\n You must select the Network Type";
    }
    if (data && data.sector =='') {
      message += " You must select the sector";
    }
    if (data && data.networkType =='') {
      message += "\n You must select the Network Type";
    }
    if (message != "") {
      alert(message);
      return;
    }
    var itemAt = getItemLayer(data);
    const featureLayer2 = window.webmap.layers.getItemAt(itemAt);
    
    var fields = featureLayer2.sourceJSON.fields;
    var cmb = "<option value='0' type2=''>Choose</option>";
    for (var i =0; i < fields.length-1; i++){
      cmb = cmb + "<option value="+fields[i].name+" type2="+fields[i].type+">"+fields[i].alias+"</option>";
    }
    document.getElementById("ddlFields").innerHTML = cmb;
    var selectElement = document.getElementById("ddlFields");
    selectElement.addEventListener('change', (event) => {
      var filterselect = selectElement.options[selectElement.selectedIndex].attributes['type2'].value;
      
      document.getElementById("ddlFilter").innerHTML = "";
      document.getElementById("txtValue").value = "";
      var cmb2 = "<option value='0'>Choose</option>";
      if (filterselect == "esriFieldTypeOID" || filterselect == "esriFieldTypeDouble" || filterselect == "esriFieldTypeInteger" || filterselect == "esriFieldTypeSmallInteger") {
        cmb2 +='<option value="=">Equal to</option>'+
        '<option value="!=">Distinct</option>'+
        '<option value=">">Greater than</option>'+
        '<option value="<">Smaller than</option>';
      }else if (filterselect == "esriFieldTypeDate") {
        cmb2 +='<option value="=">Equal to</option>'+
        '<option value=">">Greater than</option>'+
        '<option value="<">Smaller than</option>';
      } else {
        cmb2 +='<option value="=">Equal to</option>'+
        '<option value="like">Contains</option>'+
        '<option value="!=">Distinct</option>';
      }
      document.getElementById("ddlFilter").innerHTML = cmb2;
    });
  }
  const queryBuilder = (data) => {
    var element = document.getElementById("tblResult");
    document.getElementById("tblResult").innerHTML = "";
    document.getElementById("tblResult").style.display = "none";
    element.classList.remove("table-size");
    props.expandingResultTable(false);

    var ddlFields = document.getElementById("ddlFields");
    var ddlFilter = document.getElementById("ddlFilter");
    var txtValue = document.getElementById("txtValue");

    var message = "";
    if (ddlFields.value =='' || ddlFields.value =='0') {
      message += " You must select the Field";
    }
    if (ddlFilter.value =='' || ddlFilter.value =='0') {
      message += "\n You must select the Filter";
    }
    if (txtValue.value =='') {
      message += "\n You must select the value";
    }
    if (message != "") {
      alert(message);
      return;
    }

    loadModules(["esri/core/urlUtils", "esri/layers/FeatureLayer", "esri/widgets/FeatureTable", "esri/widgets/FeatureTable/Grid/support/ButtonMenu"], {
      css: true
    }).then(([urlUtils, FeatureLayer, FeatureTable, ButtonMenu]) => {

      document.getElementById("tblResult").style.display = "";
      console.log('generate table');
      element.classList.add("table-size");
      props.expandingResultTable(true);

      var itemAt = getItemLayer(data);
      const featureLayer2 = window.webmap.layers.getItemAt(itemAt);
      console.log(featureLayer2);

      var selectElement = document.getElementById("ddlFields");
      var filterselect = selectElement.options[selectElement.selectedIndex].attributes['type2'].value;
      console.log(filterselect);

      var definitionExpression = "";
      definitionExpression = ddlFields.value + ddlFilter.value + "'"+txtValue.value+"'";
      if (filterselect == "esriFieldTypeOID" || filterselect == "esriFieldTypeDouble" || filterselect == "esriFieldTypeInteger" || filterselect == "esriFieldTypeSmallInteger") {
        definitionExpression = ddlFields.value + ddlFilter.value + txtValue.value;
      }else if (filterselect == "esriFieldTypeDate") {
        definitionExpression =  " " +  ddlFields.value + " "+ ddlFilter.value + " DATE '"+txtValue.value+" 00:00:00'";
      } else {
        if (ddlFilter.value == "like")
          definitionExpression = ddlFields.value + " " + ddlFilter.value + " '%"+txtValue.value+"%'";
      }
             
      console.log(definitionExpression);
      featureLayer2.definitionExpression = definitionExpression;
      featureLayer2.resultRecordCount = 50;
      
      if (featureLayer2.popupTemplate) {
        featureLayer2.popupTemplate.actions = [
          { id: "openFileProject", title: "See File", className: "esri-icon-documentation" }
        ];
      }
      
      console.log(featureLayer2);
      featureLayer2.queryFeatures().then(e => {
        console.log(e);
        window.features = e.features;
      });

      //featureLayer.when().then(e => {
      //  console.log(e);
      //  
      //});
      
      // Create the feature table
      const featureTable = new FeatureTable({
        layer: featureLayer2,
        multiSortEnabled: true,
        view: window.view, // required for feature highlight to work
        //fieldConfigs: fieldConfigs,
        attachmentsEnabled: false,
        visibleElements: {
            selectionColumn: true,
            header: true,
            menu: true
        },
        container: document.getElementById("tblResult")
      }); 

      
    });

  }

    useEffect(() => {
      loadModules(["esri/core/watchUtils","esri/views/MapView", "esri/WebMap","esri/Map", "esri/config", "esri/widgets/Expand", "esri/layers/GraphicsLayer", "esri/widgets/Legend","esri/widgets/BasemapGallery", "esri/widgets/LayerList",
      "esri/widgets/Sketch", "esri/widgets/Print", "esri/widgets/CoordinateConversion", "esri/widgets/Bookmarks", "esri/widgets/ScaleBar", "esri/rest/identify", "esri/rest/support/IdentifyParameters", 
      "esri/widgets/DistanceMeasurement2D", "esri/widgets/AreaMeasurement2D", "esri/widgets/Home", 'esri/widgets/Sketch/SketchViewModel', 'esri/Graphic', 
      "esri/layers/FeatureLayer", "esri/widgets/FeatureTable", "esri/widgets/TimeSlider","esri/rest/support/Query","esri/renderers/HeatmapRenderer"], {
        css: true
      }).then(([watchUtils, MapView, WebMap,Map, esriConfig, Expand, GraphicsLayer, Legend, BasemapGallery, LayerList,
        Sketch, Print, CoordinateConversion, Bookmarks, ScaleBar, identify, IdentifyParameters, 
        DistanceMeasurement2D, AreaMeasurement2D, Home, SketchViewModel, Graphic,
        FeatureLayer, FeatureTable, TimeSlider,Query,HeatmapRenderer]) => {
        // then we load a web map from an id

        var bikeTrailsRenderer = {
          type: "simple",
          symbol: {
              type: "simple-line",
              style: "solid",
              color: [0, 255, 255, 0.8],
              width: "10px",
              outline: {
                  width: 10,
                  color: "#FFFF00"
              }
          }
        };

        var bikeTrailsRendererMarker = {
          type: "simple",
          symbol: {
              type: "simple-marker",
              style: "solid",
              color: [0, 255, 255, 0.8],
              width: "10px",
              outline: {
                  width: 10,
                  color: "#FFFF00"
              }
          }
        };
        esriConfig.portalUrl = URLPortal["UrlPortal"];
        const graphicsLayer = new GraphicsLayer({title:'Layer Draw'});
        const graphicsLayer2 = new GraphicsLayer({title:'Layer Selection Spatial'});
        var activeWidget = null;
        webmap = new Map({
          basemap: "topo-vector"
        });
        setWebMap(webmap);
          window.webmap = webmap;
          view = new MapView({
            map: webmap,
            container: mapEl.current,
            extent: {
              xmax: 2872197.7748430306,
              xmin: 1597839.6392729112,
              ymax: 6118363.710571125,
              ymin: 4389052.382647758,
              spatialReference: {
                wkid: 102100
              }
            }
          });
          window.view = view;


        var homeWidget = new Home({
          view: view
        });

        view.ui.add(homeWidget, "top-left");

        // //ADDED:
        // watchUtils.whenFalse(view, 'stationary', function(evt){
        //   if(!view.stationary){
        //     watchUtils.whenTrueOnce(view, 'stationary', function(evt){
        //       console.log(view.extent);
        //     });
        //   }else{
        //     watchUtils.whenFalseOnce(view, 'interacting', function(evt){
        //       console.log(view.extent);
        //     });
        //   }});

        const baseMap = new Expand({
          view,
          content: new BasemapGallery({ view }),
          expandIconClass: "esri-icon-basemap",
          expandTooltip: "Open base maps gallery",
          group: "apps-top"
        });
        view.ui.add(baseMap, "bottom-trailing");

        const legend = new Expand({
          content: new Legend({ view }),
          view,
          expandIconClass: "esri-icon-legend",
          expandTooltip: "Legend",
          group: "apps-top"
        });
        view.ui.add(legend, "bottom-trailing");

        const layerList = new Expand({
          content: new LayerList({ view }),
          view,
          expandIconClass: "esri-icon-layers",
          expandTooltip: "Display the list of layers",
          group: "apps-top"
        });
        view.ui.add(layerList, "bottom-trailing");

        const bookMark = new Expand({
          content: new Bookmarks({
            view: view,
            editingEnabled: true,
            visibleElements: {
              time: false // don't show the time (h:m:s) next to the date
            }
          }),
          view,
          expandIconClass: "esri-icon-bookmark",
          expandTooltip: "Add a bookmark",
          group: "apps-top"
        });
        view.ui.add(bookMark, "bottom-trailing");

        const sketch = new Expand({
          content: new Sketch({ layer: graphicsLayer, view, creationMode: "update" }),
          view,
          expandIconClass: "esri-icon-edit",
          expandTooltip: "Create and annotate shapes or markers on the map",
          group: "apps-top"
        });
        view.ui.add(sketch, "bottom-trailing");

        const print = new Expand({
          content: new Print({ view, printServiceUrl: "https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task" }),
          view,
          expandIconClass: "esri-icon-printer",
          expandTooltip: "Print the current map view",
          group: "apps-top"
        });
        view.ui.add(print, "bottom-trailing");

        // const conversionWidget = new Expand({
        //   content: new CoordinateConversion({ view }),
        //   view,
        //   expandIconClass: "esri-icon-map-pin",
        //   expandTooltip: "Coordinate Conversion",
        //   group: "apps-top"
        // });
        // view.ui.add(conversionWidget, "bottom-trailing");

        const scaleBar = new ScaleBar({
          view: view,
          unit: "dual", // The scale bar displays both metric and non-metric units.
          expandTooltip:"Restore map view"
        });

        // Add the widget to the bottom left corner of the view
        view.ui.add(scaleBar, { position: "bottom-left"});

        // Llamar geometria de los formularios    
        var definequery = "";
        var valores = UrlServicesFiltros[props.routeid];
        var simbologia = null;
        //checking the value of the route
        console.log("Query for the geometry", props.requesid, UrlServicesFiltrosView[props.routeid])
        if(valores == null || valores == undefined)
        {// filtrado de capa
          definequery = ""+ UrlServicesFiltrosView[props.routeid]+ "=" + props.requesid + "";
          simbologia = bikeTrailsRenderer;
        }
        else{
          definequery = ""+ UrlServicesFiltros[props.routeid]+ "=" + props.requesid + "";
          simbologia = bikeTrailsRendererMarker;
        }        
        var layerElementDefault = new FeatureLayer({
            url: UrlServices[props.routeid],
            definitionExpression: definequery,
            renderer: simbologia
        });
        
        const query = new Query();
        query.where = definequery;
        query.outSpatialReference = { wkid: 102100 };
        query.returnGeometry = true;
        query.outFields = ["*"];
        layerElementDefault.queryFeatures(query).then(function (results) {
            // prints the array of features to the console
            if (results.features.length == 0) {              
              alert("This type of form has no geometry")                   
              return;
            }
            //console.log(results);
            if(results.features[0].layer.geometryType == "point")
            {
              view.goTo({
                center: [results.features[0].geometry.longitude, results.features[0].geometry.latitude],
                zoom: 12
              });
            }
            else
            {
              view.goTo({
                target: results.features
              });
            }
           
        }); 
        webmap.add(layerElementDefault, 0);
        //WIDGET MEASURE
        // let node = domConstruct.create("div", {
        //   class:'esri-ui-top-right esri-ui-corner',
        // });

        // let div = domConstruct.create("div", {
        //   id:"topbar",
        //   class:'esri-component'
        // }, node);

        // domConstruct.create("button", {
        //   class:'esri-button action-button esri-icon-measure-line',
        //   title:"Measure distance between two or more points",
        //   id:"distanceButton",
        //   onclick: function() { distanceButton(this) }
        // }, div);

        // domConstruct.create("button", {
        //   class:'esri-button action-button esri-icon-measure-area',
        //   title:"Measure area",
        //   id:"areaButton",
        //   onclick: function() { areaButton(this) }
        // }, div);

        // function distanceButton(e) {
        //   setActiveWidget(null);
        //   if (!e.classList.contains("active")) {
        //     setActiveWidget("distance");
        //   } else {
        //     setActiveButton(null);
        //   }
        // }

        // function areaButton(e) {
        //   setActiveWidget(null);
        //   if (!e.classList.contains("active")) {
        //     setActiveWidget("area");
        //   } else {
        //     setActiveButton(null);
        //   }
        // }

        // function setActiveWidget(type) {
        //   switch (type) {
        //     case "distance":
        //       activeWidget = new DistanceMeasurement2D({
        //         view: view
        //       });
        //       // skip the initial 'new measurement' button
        //       activeWidget.viewModel.start();
        //       view.ui.add(activeWidget, "top-right");
        //       setActiveButton(document.getElementById("distanceButton"));
        //       break;
        //     case "area":
        //       activeWidget = new AreaMeasurement2D({
        //         view: view
        //       });
        //       // skip the initial 'new measurement' button
        //       activeWidget.viewModel.start();
        //       view.ui.add(activeWidget, "top-right");
        //       setActiveButton(document.getElementById("areaButton"));
        //       break;
        //     case null:
        //       if (activeWidget) {
        //         view.ui.remove(activeWidget);
        //         activeWidget.destroy();
        //         activeWidget = null;
        //       }
        //       break;
        //   }
        // }

        // function setActiveButton(selectedButton) {
        //   // focus the view to activate keyboard shortcuts for sketching
        //   view.focus();
        //   var elements = document.getElementsByClassName("active");
        //   for (var i = 0; i < elements.length; i++) {
        //     elements[i].classList.remove("active");
        //   }
        //   if (selectedButton) {
        //     selectedButton.classList.add("active");
        //   }
        // }

        // const measureWidget = new Expand({
        //   content: node,
        //   view,
        //   expandIconClass: "esri-icon-measure",
        //   expandTooltip: "Measure",
        //   group: "apps-top"
        // });
        // view.ui.add(measureWidget, "bottom-trailing");

        //WIDGET TIMESLIDER
        /*const timeSlider = new TimeSlider({
          view: view,
          timeVisible: true, // show the time stamps on the timeslider
          stops : {
            interval: {
              value: 3,
              unit: "years"
            }
          },
          loop: true
        });
        */
        //view.ui.add(timeSlider, "bottom-leading");

        //WIDGET SELECTION SPATIAL
        // let divContentSpatial = domConstruct.create("div", {
        //   class:'card esri-widget esri-widget--panel',
        // });

        // let divContent = domConstruct.create("div", {
        //   class:'card-body pb-0',
        //   innerHTML :'<h6 class="card-title">Select geometry</h6>'
        // }, divContentSpatial);

        // let divSpatial = domConstruct.create("div", {
        //   id:"topbar",
        // }, divContent);

        // domConstruct.create("button", {
        //   class:'esri-button action-button esri-icon-radio-unchecked',
        //   title:"Measure distance between two or more points",
        //   id:"distanceButton",
        //   onclick: function() { sketchSelectionSpatial.create("circle");  }
        // }, divSpatial);

        // domConstruct.create("button", {
        //   class:'esri-button action-button esri-icon-checkbox-unchecked',
        //   title:"Measure distance between two or more points",
        //   id:"distanceButton",
        //   onclick: function() { sketchSelectionSpatial.create("rectangle", { mode: "freehand" }); }
        // }, divSpatial);

        // domConstruct.create("button", {
        //   class:'esri-button action-button esri-icon-polygon',
        //   title:"Measure distance between two or more points",
        //   id:"distanceButton",
        //   onclick: function() { sketchSelectionSpatial.create("polygon", { mode: "click" }); }
        // }, divSpatial);

        // domConstruct.create("button", {
        //   class:'esri-button action-button esri-icon-feature-layer',
        //   title:"Measure distance between two or more points",
        //   id:"distanceButton",
        //   onclick: function() { sketchSelectionSpatial.create("polygon", { mode: "freehand" }); }
        // }, divSpatial);

        // const selectionSpatialWidget = new Expand({
        //   content: divContentSpatial,
        //   view,
        //   expandIconClass: "esri-icon-applications",
        //   expandTooltip: "Selection Spatial",
        //   group: "apps-top"
        // });
        // view.ui.add(selectionSpatialWidget, "bottom-trailing");

        // function fromMapReport(geometry){
        //   if (geometry !== null) {
        //     let feature = new Graphic({
        //         geometry: geometry,
        //         symbol: { type: "simple-fill" }
        //     });
        //     graphicsLayer2.add(feature);
        //   }
        // }

        //WIDGET QUERY BUILDER
        // let divContentQuery = domConstruct.create("div", {
        //   class:'card esri-widget esri-widget--panel',
        // });

        // let divContentQuery2 = domConstruct.create("div", {
        //   class:'card-body pb-0 pt-1',
        // }, divContentQuery);

        // let divContentQuery3 = domConstruct.create("div", {
        //   class:'text-center',
        // }, divContentQuery2);

        //domConstruct.create("h6", {
        //  class:'card-title',
        //  innerHTML :'Select Fields &nbsp;'
        //}, divContentQuery3);
        
        // let divContentQuery4 = domConstruct.create("div", {
        //   class:'',
        // }, divContentQuery3);

        // domConstruct.create("button", {
        //   class:'ter_styles btn btn-primary btn-sm esri-icon-rotate',
        //   title:" Load Fields",
        //   innerHTML:" Load Fields",
        //   id:"areaButton",
        //   onclick: function() { setFields(window.filter) }
        // }, divContentQuery4);

        // let divContentBody3 = domConstruct.create("div", {
        //   class:'',
        //   innerHTML :'<div class="mt-2 d-flex"><span>Field: &nbsp;&nbsp;&nbsp;</span><select id="ddlFields" class="form-control form-control-sm input_ddl_styles"><option val="0">Choose</option></select></div>' +
        //   '<div class="mt-2 d-flex"><span>Filter: &nbsp;&nbsp;&nbsp;</span><select id="ddlFilter" class="form-control form-control-sm input_ddl_styles"></select></div>' +
        //   '<div class="mt-2 d-flex"><span>Value: &nbsp;&nbsp;&nbsp;</span><input class="form-control form-control-sm input_ddl_styles" type="text" id="txtValue"/></div>'
        // }, divContentQuery2);       

        // let divTopbarSearchQuery = domConstruct.create("div", {
        //   id:"topbar",
        // }, divContentBody3);

        // domConstruct.create("button", {
        //   class:'esri-button action-button esri-icon-search',
        //   title:"Apply",
        //   innerHTML:" Apply",
        //   id:"areaButton",
        //   onclick: function() { queryBuilder(window.filter) }
        // }, divTopbarSearchQuery);

        /*const queryBuilderWidget = new Expand({
          content: divContentQuery,
          view,
          expandIconClass: "esri-icon-settings2",
          expandTooltip: "Query Builder",
          group: "apps-top"
        });
        view.ui.add(queryBuilderWidget, "bottom-trailing");*/

        view.when(function() {
          let popup = view.popup;
          popup.viewModel.on("trigger-action", event => {
              //console.log(popup.viewModel.selectedFeature);
              if (event.action.id === "openFileProject") {
                var attributes = popup.viewModel.selectedFeature.attributes;
                var id = attributes["npm_road_id"];
                attributes.countryCode = attributes.country_code;
                props.requestData(attributes);
                var element = document.getElementById("tblResult");
                document.getElementById("tblResult").innerHTML = "";
                document.getElementById("tblResult").style.display = "none";
                element.classList.remove("table-size");
                props.expandingResultTable(false);
                props.expanding();
              }
          });
        });

      });
      return () => {
        if (!!view) {
          view.destroy();
          view = null;
        }
      };

    }, [props.requesid])

    
    
    return (
      <Container fluid className={style.todisSharingMapWrapper}>
      <div style={{ height: props.resultTable == true ? "calc(100vh - 420px)" : "calc(100vh - 130px)", width: props.fullMap ? "100%": "100%" }}  ref={mapEl} />
      <Button variant="primary" onClick={props.expanding} className="expand-map-btn">{props.fullMap ? "Hide the map display": "Full Map"}</Button>
      </Container>
    )

}

export default TODIS_MAP;